import React from "react"
import styled, { css } from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"
import { Row, Col } from "reactstrap"
import { media } from "utils/Media"
import BlockTitle from "components/shared/BlockTitle"
import ContainerMax from "components/shared/ContainerMax"
import ContentMax from "components/shared/ContentMax"
import WPLink from "components/shared/WPLink"
import Text from "components/shared/Text"

const ContentMaxStyled = styled(ContentMax)`
	position: relative;
	z-index: 2;
	color: white;
	margin-top: 1rem;
	/* @media ${media.md} {
		padding-left: 2rem;
		padding-right: 2rem;
	} */

	@media (min-width: 1600px) {
		padding-left: 0;
		padding-right: 0;
	}

	${props => props.button && css`
	/* position: absolute;
	bottom: -4rem; */
	`}
`

const HorizontalImageText = (props) => {
	return(
		<ContainerMax className={`my-4 ${props.block.link ? "mb-5" : ""}`}>
			<ContentMax>
				<Row className="align-items-md-center">
					{props.block.image &&
						<Col sm={4} className="pb-3 pb-md-0">
							<GatsbyImage
								image={props.block.image.localFile.childImageSharp.gatsbyImageData}
								alt={props.block.image.altText} 
							/>   
						</Col>
					}
					<Col sm={8}>
						{props.block.title && 
							<BlockTitle newsTitle >{props.block.title}</BlockTitle>
						}
						{props.block.text && 
							<Text as="div" white dangerouslySetInnerHTML={{ __html: props.block.text }} />
						}
				{props.block.link && 
					<ContentMaxStyled button >
						<WPLink url={props.block.link.url} target={props.block.link.target} button color="main">
							{props.block.link.title}
						</WPLink>
					</ContentMaxStyled>
				}
					</Col>
				</Row>
			</ContentMax>
		</ContainerMax>
	)
}

export default HorizontalImageText